import { CartLinesUpdateEvent } from '@shopify/events';

const kok = () => window.Shopify?.routes?.root || '/';
const azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const bolumler = () => [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);

function bildir(metin) {
  let t = document.querySelector('.k-toast');
  if (!t) { t = document.createElement('div'); t.className = 'k-toast'; t.setAttribute('role', 'status'); document.body.append(t); }
  t.textContent = metin;
  t.classList.add('is-on');
  clearTimeout(t._z); t._z = setTimeout(() => t.classList.remove('is-on'), 2200);
}

function sepetZipla() {
  document.querySelectorAll('cart-icon, .header-actions__cart-icon, [data-testid="cart-icon"]').forEach((e) => {
    e.classList.remove('k-zipla'); void e.offsetWidth; e.classList.add('k-zipla');
  });
}

export async function sepeteEkle(kaynak, varyantId, adet = 1) {
  const ertelenen = CartLinesUpdateEvent.createPromise();
  kaynak.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(varyantId), quantity: adet }], promise: ertelenen.promise }));
  try {
    const yanit = await fetch(`${kok()}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(varyantId), quantity: adet }].map((x) => window.kitchSatir?.(x) ?? x), sections: bolumler().join(',') }),
    }).then((r) => r.json());
    const sepet = await fetch(`${kok()}cart.js`).then((r) => r.json());
    ertelenen.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet), detail: { items: sepet.items, source: 'kitch-ui', itemCount: adet, sections: yanit.sections, didError: Boolean(yanit.status) } });
    if (yanit.status) throw new Error(yanit.description || 'Sepete eklenemedi');
    sepetZipla();
    if (!document.querySelector('cart-drawer-component')) window.location.href = `${kok()}cart`;
    return true;
  } catch (e) {
    ertelenen.reject(e);
    bildir(e.message && e.message.length < 80 ? e.message : 'Bağlantı sorunu oldu, tekrar dene.');
    return false;
  }
}
window.kitchSepeteEkle = sepeteEkle;
window.kitchSepetZipla = sepetZipla;

/* hızlı ekle */
document.addEventListener('click', async (e) => {
  const b = e.target instanceof Element ? e.target.closest('[data-hizli-ekle]') : null;
  if (!b) return;
  e.preventDefault();
  if (b.disabled) return;
  b.disabled = true; b.classList.add('is-bekle');
  const ok = await sepeteEkle(b, b.dataset.varyant);
  b.classList.remove('is-bekle');
  if (ok) { b.classList.add('is-tamam'); const s = b.querySelector('span'); const eski = s.textContent; s.textContent = 'Sepette'; setTimeout(() => { b.classList.remove('is-tamam'); s.textContent = eski; }, 1800); }
  b.disabled = false;
});

/* koleksiyon filtre + sıralama (istemci tarafı; koleksiyonlar ≤48 ürün) */
document.querySelectorAll('[data-arac]').forEach((arac) => {
  const izgara = arac.parentElement.querySelector('[data-izgara]');
  if (!izgara) return;
  const kartlar = [...izgara.querySelectorAll('[data-kart]')];
  const ilkSira = kartlar.slice();
  const say = arac.querySelector('[data-say]');
  let filtre = 'hepsi';
  const uygula = () => {
    let n = 0;
    kartlar.forEach((k) => { const g = filtre === 'hepsi' || k.dataset.tur === filtre; k.hidden = !g; if (g) n += 1; });
    if (say) say.textContent = n;
  };
  arac.querySelectorAll('[data-filtre]').forEach((c) => c.addEventListener('click', () => {
    filtre = c.dataset.filtre;
    arac.querySelectorAll('[data-filtre]').forEach((x) => { x.classList.toggle('is-on', x === c); x.setAttribute('aria-pressed', String(x === c)); });
    const gecis = () => uygula();
    if (document.startViewTransition && !azHareket) document.startViewTransition(gecis); else gecis();
  }));
  arac.querySelector('[data-sirala]')?.addEventListener('change', (ev) => {
    const v = ev.target.value;
    const sirali = v === 'onerilen' ? ilkSira : kartlar.slice().sort((a, b) => {
      if (v === 'ad') return a.dataset.ad.localeCompare(b.dataset.ad, 'tr');
      const f = Number(a.dataset.fiyat) - Number(b.dataset.fiyat);
      return v === 'fiyat-artan' ? f : -f;
    });
    const gecis = () => sirali.forEach((k) => izgara.append(k));
    if (document.startViewTransition && !azHareket) document.startViewTransition(gecis); else gecis();
  });
});

/* başlık: kaydırınca dolu + incelir */
const kaydir = () => document.documentElement.classList.toggle('k-kaydi', window.scrollY > 24);
kaydir();
window.addEventListener('scroll', kaydir, { passive: true });

/* kademeli beliriş: [data-stagger] içindeki çocuklara sıra */
document.querySelectorAll('[data-stagger]').forEach((g) => {
  [...g.children].forEach((c, i) => { c.style.setProperty('--k-sira', i); c.classList.add('k-belir'); });
});

/* hafif parallax: [data-parallax] görselleri (yalnız hareket izni varsa) */
if (!azHareket) {
  const px = [...document.querySelectorAll('[data-parallax], .ka-muhur__resim, .k-kol-bas__resim, .k-son__resim img')];
  if (px.length) {
    let bekliyor = false;
    const ciz = () => {
      bekliyor = false;
      const h = window.innerHeight;
      px.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > h) return;
        const oran = (r.top + r.height / 2 - h / 2) / h;
        el.style.transform = `translate3d(0, ${(oran * -36).toFixed(1)}px, 0) scale(1.08)`;
      });
    };
    window.addEventListener('scroll', () => { if (!bekliyor) { bekliyor = true; requestAnimationFrame(ciz); } }, { passive: true });
    ciz();
  }
}

/* teklif bandı: fiyatlar görününce sayarak gelir */
const tlUi = (k) => { const n = k / 100; const t = Math.floor(n); const r = Math.round((n - t) * 100); return `${t.toLocaleString('tr-TR')}${r ? ',' + String(r).padStart(2, '0') : ''} ₺`; };
const sayilar = document.querySelectorAll('[data-say-tl]');
if (sayilar.length && !azHareket && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver((gl) => gl.forEach((g) => {
    if (!g.isIntersecting) return;
    io.unobserve(g.target);
    const el = g.target; const hedef = Number(el.dataset.sayTl); const t0 = performance.now(); const sure = 1100;
    const adim = (t) => { const o = Math.min(1, (t - t0) / sure); const e = 1 - (1 - o) ** 4; el.textContent = tlUi(o === 1 ? hedef : Math.round((hedef * e) / 100) * 100); if (o < 1) requestAnimationFrame(adim); };
    requestAnimationFrame(adim);
  }), { threshold: 0.6 });
  sayilar.forEach((e) => io.observe(e));
}

/* video karuseli: görünen kartlar sessiz döngü oynar; dokununca tam ekran sesli */
document.querySelectorAll('[data-kv]').forEach((kok) => {
  const kartlar = [...kok.querySelectorAll('.kv-kart')];
  /* posterler ilk görselle yarışmasın: ray ekrana yaklaşınca yüklenir */
  const posterKoy = () => kartlar.forEach((k) => { const v = k.querySelector('video'); if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster; });
  if ('IntersectionObserver' in window) {
    const pio = new IntersectionObserver((gl) => { if (gl.some((g) => g.isIntersecting)) { posterKoy(); pio.disconnect(); } }, { rootMargin: '400px 0px' });
    pio.observe(kok);
  } else posterKoy();
  const dlg = kok.querySelector('[data-kv-dlg]'); const oyn = kok.querySelector('[data-kv-oynat]');
  if (!azHareket && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((gl) => gl.forEach((g) => {
      const v = g.target.querySelector('video');
      if (g.isIntersecting) { if (!v.src) v.src = v.dataset.kvOn; v.play().catch(() => {}); } else if (v.src) v.pause();
    }), { threshold: 0.55 });
    kartlar.forEach((k) => io.observe(k));
  }
  let son = null;
  kartlar.forEach((k) => k.addEventListener('click', () => {
    son = k; oyn.src = k.dataset.kvTam; oyn.muted = false;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    oyn.play().catch(() => {});
  }));
  const kapat = () => { oyn.pause(); oyn.removeAttribute('src'); oyn.load(); if (dlg.open) dlg.close(); son?.focus(); };
  kok.querySelector('[data-kv-kapat]').addEventListener('click', kapat);
  dlg.addEventListener('cancel', (e) => { e.preventDefault(); kapat(); });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) kapat(); });
});

/* yatay ray ok düğmeleri */
document.querySelectorAll('[data-ray-ok]').forEach((b) => b.addEventListener('click', () => {
  const ray = b.closest('section')?.querySelector('[data-ray]');
  if (!ray) return;
  const kart = ray.firstElementChild; const adim = kart ? kart.getBoundingClientRect().width + 16 : ray.clientWidth * 0.8;
  ray.scrollBy({ left: adim * Number(b.dataset.rayOk), behavior: azHareket ? 'auto' : 'smooth' });
}));
